import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const resetButton = (theme: ExactTheme) =>
  css({
    cursor: "pointer",
    border: `1px solid transparent`,
    padding: "0 10px",
    borderRadius: 15,
    height: "25px",
    flexShrink: 0,
    transition: "all 0.150s ease-out", // todo: move transitions to theme
    ":hover": {
      border: `1px solid ${theme.colorsV2.red[500]}`,
      i: {
        color: theme.colorsV2.red[500],
      },
    },
  });

export const resetIcon = (theme: ExactTheme) =>
  css({
    color: theme.colorsV2.blue[500],
  });

export const root = (theme: ExactTheme) =>
  css({
    display: "flex",
    paddingRight: "15px",
    paddingLeft: "15px",
    paddingTop: "10px",
    paddingBottom: 0,
    gap: "10px",
    flexShrink: 0,
    flexWrap: "wrap",
  });

export const chip = css({
  flexShrink: 0,
});
